import { render, staticRenderFns } from "./OpportunityItem.vue?vue&type=template&id=510cd7b4&scoped=true&"
import script from "./OpportunityItem.vue?vue&type=script&lang=js&"
export * from "./OpportunityItem.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityItem.vue?vue&type=style&index=0&id=510cd7b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510cd7b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VCard,VCardActions,VIcon,VListItem,VListItemContent,VListItemIcon,VListItemSubtitle,VListItemTitle})
